import { render } from "./ReleaseStatusForm.vue?vue&type=template&id=ae4a2d86&scoped=true&ts=true"
import script from "./ReleaseStatusForm.vue?vue&type=script&lang=ts"
export * from "./ReleaseStatusForm.vue?vue&type=script&lang=ts"

import "./ReleaseStatusForm.vue?vue&type=style&index=0&id=ae4a2d86&scoped=true&lang=css"

import exportComponent from "C:\\repo\\ono\\ops-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae4a2d86"]])

export default __exports__